import { Client, Controller, Endpoint, mapUrl } from "@/repository";
import { Queue, QueueType, QueueWithResources } from "@/repository/models";

export const fetchMemberedQueues = async (): Promise<Queue[]> => {
	const promises: Promise<Queue[]>[] = [
		Client.instance.get(Controller.VoiceQueues),
		Client.instance.get(Controller.MessagingQueues),
	];
	const allQueues = await Promise.all(promises);

	return allQueues.flatMap((x: Queue[]) => x);
};

export const fetchMemberedQueuesWithResources = async (
	currentInteractionId: string
): Promise<QueueWithResources[]> => {
	const promises: Promise<QueueWithResources[]>[] = [
		Client.instance.get(mapUrl(Controller.VoiceQueues, Endpoint.Resources)),
		Client.instance.get(
			mapUrl(Controller.MessagingQueues, Endpoint.Resources),
			{ interactionId: currentInteractionId }
		),
	];
	const allQueues = await Promise.all(promises);

	return allQueues.flatMap((x: QueueWithResources[]) => x);
};

export const setQueueJoinStatus = (
	id: string,
	type: QueueType,
	joined: boolean
): Promise<any> => {
	const action = joined ? Endpoint.Join : Endpoint.UnJoin;
	const url = mapUrl(mapQueueType(type), id, action);

	return Client.instance.post(url);
};

export const checkEnableCallSummary = (queueId: string): Promise<boolean> => {
	return Client.instance.get(
		mapUrl(Controller.QueueSettings, queueId, Endpoint.EnableCallSummary)
	);
};

export const checkEnableTextSummary = (queueId: string): Promise<boolean> => {
	return Client.instance.get(
		mapUrl(
			Controller.MessagingQueueSettings,
			queueId,
			Endpoint.EnableTextSummary
		)
	);
};

export const fetchQueueTranscriptionLanguage = (queueId: string): Promise<string> => {
	return Client.instance.get(
		mapUrl(Controller.QueueSettings, queueId, Endpoint.TranscriptionLanguageSetting)
	);
};

const mapQueueType = (type: QueueType): Controller => {
	switch (type) {
		case QueueType.Voice:
			return Controller.VoiceQueues;
		case QueueType.Messaging:
			return Controller.MessagingQueues;
		default:
			throw `Queue type [${QueueType[type]}] is not configured`;
	}
};
